module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "podpisovyModal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.podpisProps.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n          Datum: " + _vm._s(_vm.human_readable_today()) + "\n          ")]), _vm._v(" "), _c('p', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "signed-name"
    }
  }, [_vm._v(_vm._s(_vm.podpisProps.caption))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signedName),
      expression: "signedName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "signed-name",
      "disabled": _vm.signInProgress,
      "disabled": ""
    },
    domProps: {
      "value": (_vm.signedName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signedName = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chyba při podepisování dokumentu"), _c('br'), _vm._v(_vm._s(_vm.displayError) + "\n              ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "d-flex w-100"
  }, [_c('div', {
    staticClass: "flex-grow-1 text-left"
  }, [_c('button', {
    staticClass: "btn btn-outline=default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.signInProgress
    }
  }, [_vm._v("\n                Zpět\n              ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.signInProgress
    },
    on: {
      "click": function($event) {
        _vm.podepsatDokument()
      }
    }
  }, [_vm._v("\n                Podepsat dokument\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9fd07da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgreementSign.vue
// module id = 329
// module chunks = 1 2